<template>
  <div></div>
</template>

<script>
import { session, config, api } from "@/assets/js/util.js";

export default {
  name: "Logout",
  data() {
    return {
      system_name: "青岛精科商城",
    };
  },
  mounted() {
    api.post("logout", {}).then((res) => {
      if (res.code == 1) {
        session.clear();
        config.clear();
        this.$router.push("/");
      }
    });
  },
  methods: {
    onSendVerificationCode() { },
  },
};
</script>
